import { ModuleWithProviders, NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzProgressSpinnerModule } from '@blk/daisy/core/loading';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { ErrorWithExclamationComponent } from './components/error-with-exclamation/error-with-exclamation.component';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { ResponseMessageDialogComponent } from './components/response-message-dialog/response-message-dialog.component';
import { ErrorPageComponent } from './lib/error-page/error-page.component';
import { ErrorHandlerConfig, ErrorHandlerConfigService } from './models/error-handler-config.interface';
import { ErrorHandlerService } from './services/error-handler.service';
import { ErrorHelperService } from './services/error-helper.service';
import { ErrorPopupService } from './services/error-popup.service';

@NgModule({
	declarations: [ResponseMessageDialogComponent, ErrorPageComponent, ErrorWithExclamationComponent, LoadingSpinnerComponent],
	imports: [
		CwpNgFrameworkModule,
		SharedModule,
		AnalyticsModule,
		DzButtonModule,
		GenericDirectivesModule,
		DzProgressSpinnerModule
	],
	exports: [ResponseMessageDialogComponent, ErrorPageComponent, ErrorWithExclamationComponent]
})
export class ErrorHandlerModule {
	public static forRoot(config: ErrorHandlerConfig): ModuleWithProviders<ErrorHandlerModule> {
		return {
			ngModule: ErrorHandlerModule,
			providers: [
				ErrorHandlerService,
				ErrorPopupService,
				ErrorHelperService,
				{
					provide: ErrorHandlerConfigService,
					useValue: config
				}
			]
		};
	}
}
